import { API_BASE } from '../config';

export interface StorageFile {
    name: string;
    size: number;
    modified: string;
}

export const listStorageFiles = async (workflowId: string): Promise<StorageFile[]> => {
    const res = await fetch(`${API_BASE}/workflows/${workflowId}/storage`);
    if (!res.ok) throw new Error('Failed to list storage files');
    return res.json();
};

export const uploadFiles = async (workflowId: string, files: File[]): Promise<{ success: boolean; files: { name: string; size: number }[] }> => {
    const formData = new FormData();
    for (const file of files) formData.append('files', file);
    const res = await fetch(`${API_BASE}/workflows/${workflowId}/storage/upload`, {
        method: 'POST',
        body: formData,
    });
    if (!res.ok) throw new Error('Failed to upload files');
    return res.json();
};

export const downloadFile = (workflowId: string, filename: string): void => {
    window.open(`${API_BASE}/workflows/${workflowId}/storage/${encodeURIComponent(filename)}`, '_blank');
};

export const deleteFile = async (workflowId: string, filename: string): Promise<void> => {
    const res = await fetch(`${API_BASE}/workflows/${workflowId}/storage/${encodeURIComponent(filename)}`, {
        method: 'DELETE',
    });
    if (!res.ok) throw new Error('Failed to delete file');
};
